'use client';

import type { FC, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import { useDataPopup } from '../hooks/useDataPopup';
import { useTruth } from '../hooks/useTruth';
import { messages } from '../messages';

interface ConditionAdBlockerProps extends PropsWithChildren {
  enabled?: string;
  disabled?: string;
}

export const ConditionAdBlocker: FC<ConditionAdBlockerProps> = ({
  enabled,
  disabled,
  children,
}) => {
  const { dataBlocks } = useTruth();
  const { adBlocker } = dataBlocks;
  const { DataPopup } = useDataPopup();
  const [handle, setHandle] = useState<React.ReactNode>(children);

  useEffect(() => {
    if (adBlocker?.value === 'yes') {
      setHandle(enabled);
    } else {
      setHandle(disabled);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- branch props are static JSX; keyed on the detected value
  }, [adBlocker?.value]);

  return (
    <DataPopup
      handle={handle}
      subheading={messages['condition.adBlocker.description']}
      condition={{
        title: messages['condition.adBlocker'],
        options: [
          {
            title: messages['condition.adBlocker.enabled'],
            value: enabled,
          },
          {
            title: messages['condition.adBlocker.disabled'],
            value: disabled,
          },
        ],
      }}
      dataBlocks={{ adBlocker }}
    />
  );
};
